import { render, staticRenderFns } from "./CreateCategoryDialog.vue?vue&type=template&id=7b1d482d&scoped=true"
import script from "./CreateCategoryDialog.vue?vue&type=script&lang=js"
export * from "./CreateCategoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1d482d",
  null
  
)

export default component.exports